












































































import PagedMixin from '@/common/pagination/mixins/paged-mixin'
import User from '@/users/entities/user'
import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class UsersTable extends Mixins(PagedMixin) {
  @Prop({ type: Boolean, default: false })
  private loading!: boolean

  @Prop({ default: () => [] })
  private users!: User[]

  private get headers() {
    return [
      {
        text: this.$tc('common.name.full'),
        value: 'name',
        sortable: false,
      },
      {
        text: this.$tc('common.email.singular'),
        value: 'email',
        sortable: false,
      },
      {
        text: this.$tc('common.address.singular'),
        value: 'address',
        sortable: false,
      },
      {
        text: this.$tc('users.roles.title.singular'),
        value: 'role',
        sortable: false,
      },
      {
        text: this.$tc('users.status.title.singular'),
        value: 'status',
        sortable: false,
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        class: 'table-actions',
        align: 'end',
      },
    ]
  }

  private edit(user: User) {
    this.$emit('edit', user)
  }

  private impersonate(user: User) {
    this.$emit('impersonate', user)
  }

  private enable(user: User) {
    this.$emit('enable', user)
  }

  private disable(user: User) {
    this.$emit('disable', user)
  }

  private remove(user: User) {
    if (confirm(this.$tc('users.components.users-table.confirm_remove'))) {
      this.$emit('delete', user)
    }
  }
}
